import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'storyblok-link',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.scss'],
})

export class StoryBlokLinkComponent implements OnInit {
    @Input() data : any;
    @Input() color : string;
    @Input() classList = [];
    
    href = "";
    target = "";
    title = "";

    constructor(
        public translate: TranslateService,
    ) {
    }

    ngOnInit() {
        if (this.data.linktype === "url") {
            this.href = this.formatLink(this.data.cached_url);
            this.target = this.isTargetBlank(this.data.cached_url) ? "_blank" : undefined;
            this.title = this.data.title || this.data.cached_url;
        }

        if (this.data.linktype === "story") {
            const url = this.data.cached_url.startsWith("/") ? this.data.cached_url : `/${this.data.cached_url}`;
        
            //remove /core/
            const parts = url.split("/");
            const rest = this.translate.currentLang != 'de_CH' ? parts.slice(3) : parts.slice(2);
            this.href = "/me/" + rest.join("/");
            this.target = this.data.target;
        
            if(this.isLastSegmentOfUrl(parts.at(-1))){
                // Scroll top if in current page
                this.href += '#';
            }

            if (!this.data.story) {
                this.title = this.data.title || this.data.cached_url;
                return;
            }

            this.title = this.data.title
              ? this.data.title
              : this.isTranslated(this.translate.currentLang, this.data.story)
              ? this.data.story!.translated_slugs[0]?.name
              : this.data.story!.name;

        }
    }

    isTargetBlank(url: string) {
        return (
          url.includes("http") ||
          url.includes("tel:") ||
          url.includes("mailto:") ||
          url.includes("sms:")
        );
    }

    isTranslated(locale, story?) {
        return (
          locale !== "de_CH" &&
          story &&
          story.translated_slugs &&
          story.translated_slugs.length > 0
        );
    }

    formatLink(url: string) {
        let link = url.split('/');
        if (link[0] == '') {
            link[0] = 'me';
        }

        return link.join('/');
    }

    isLastSegmentOfUrl(href: string): boolean {
        // Get the current URL's pathname
        const currentPathname = window.location.pathname;

        // Split the pathname into segments, filtering out empty segments
        const segments = currentPathname.split('/').filter(segment => segment.length > 0);

        // Get the last segment of the current URL
        const lastSegment = segments.length > 0 ? segments[segments.length - 1] : '';

        // Compare the last segment with the provided href
        return lastSegment === href;
    }
}

